<div class="search" *transloco="let t">
    <mat-form-field class="search-panel" appearance="outline">
      <input matInput #searchTerm placeholder="{{t('search')}}..." (keyup.enter)="control.valid? searchClickAction(): null" [formControl]="control" maxlength="255">
      <div class="icon" matPrefix>
        <nb-icon icon="search-outline"></nb-icon>
      </div>
      <div class="clear" matSuffix>  
        <button *ngIf="searchTerm.value" mat-icon-button (click)="handleClearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    <mat-error>{{error}}</mat-error>
    </mat-form-field>
  </div>
